<template>
  <Layout>
    <div class="row m-0" style="margin-top: 50px !important;margin-right:  -12px !important;margin-left:  -12px !important;">
      <div class="col-md-12 p-0" v-if="modelKySo.path">
        <PdfEditorLocal :fileInfo="modelKySo" :pdf="`${modelKySo.path}`" />
      </div>
    </div>
  </Layout>
</template>

<script>

import appConfig from "@/app.config.json";
import Layout from "../../layouts/main";
import {CURRENT_USER} from "@/helpers/currentUser";
import {notifyModel} from "@/models/notifyModel";
import PdfEditorLocal from "@/components/pdfEdtitorLocal/PdfEditorLocal";

export default {
  name: "thietLapKySo",
  page: {
    title: "Ký số",
    meta: [{name: "description", content: appConfig.description}],
  },
  components:{
    PdfEditorLocal,
    Layout,
    // CountDownClock
  },
  async created() {
    this.vanBanDiId = this.$route.params.id;
    await this.getVanBanDiById(this.$route.params.id);
  },
  computed:{
  },
  data() {
    return {
      title: "Ký số nội bộ",
      apiUrl: process.env.VUE_APP_API_URL,
      apiViewFile: process.env.VUE_APP_API_URL + 'files/view/',
      files: null,
      showModalClock: true,
      vanBanDiId: null,
      modelKySo: {
        fileName: null,
        path: null,
        vanBanDiId: null
      }
    };
  },
  methods:{
    async getVanBanDiById(id){
      await this.$store.dispatch("vanBanDiStore/getById", id).then((res) => {
        if (res.resultCode == "SUCCESS") {
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage({resultString: "Tải văn bản thành công", resultCode: res.resultCode}));
          this.modelKySo.vanBanDiId = res.data.id;
          if (res.data.file) {
            this.modelKySo.fileName = res.data.file[0].fileName;
            this.modelKySo.path = this.apiViewFile + res.data.file[0].fileId;
          }else{
            this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage({resultString: "Không tìm thấy tệp tin cần ký số", resultCode: "ERORR"}));
          }
        } else {
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        }
      });
    }
  }
}
</script>

<style scoped>

</style>